import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/views/main/Home')
const Seller = () => import('@/views/main/member/Seller')
const Buyer = () => import('@/views/main/member/Buyer')
const Product = () => import('@/views/main/product/List')
const Order = () => import('@/views/main/order/List')
const User = () => import('@/views/main/system/User')
const Reviewwnr = () => import('@/views/main/data/ReviewWnr')
const Reviewamazon = () => import('@/views/main/data/ReviewAmazon')
const Reviewsocial = () => import('@/views/main/data/ReviewSocial')
const VIP_Application = () => import('@/views/main/member/VIP_Application')
const Cashout = () => import('@/views/main/member/Cashout')
const Ad = () => import('@/views/main/system/AD')
const Hk = () => import('@/views/main/system/HotKeyword')
const Operatelog = () => import('@/views/main/system/OperateLog')
const Role = () => import('@/views/main/system/Role')
const BalanceRecordList  = () => import('@/views/main/financial/balance_record_list')
const WithdrawTransfer  = () => import('@/views/main/financial/withdraw_transfer')
const RechargeRecord  = () => import('@/views/main/financial/recharge_record_list')
const SettingPage = ()=> import('@/views/main/system/Setting')
const CommentPage = ()=> import('@/views/main/blog/comment/comment_list')
const NoticePage = ()=> import('@/views/main/notice/notice_list')
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: Home
    },
    {
      name:'Buyer List',
      path: '/member/buyer_list',
      component: Buyer
    },
    {
      path: '/member/seller_list',
      component: Seller
    },
    {
      path: '/product/list',
      component: Product
    },
    {
      path: '/order/list',
      component: Order
    },
    {
      path: '/blog/comment_list',
      component: CommentPage
    },
    {
      path: '/notice/notice_list',
      component: NoticePage
    },
    {
      path: '/member/user_list',
      component: User
    },
    {
      path: '/data/reviews_amazon',
      component: Reviewamazon
    },
    {
      path: '/data/reviews_social',
      component: Reviewsocial
    },
    {
      path: '/data/reviews_wnr',
      component: Reviewwnr
    },
    {
      path: '/member/cashout',
      component: Cashout
    },
    {
      path: '/system/ad',
      component: Ad
    },
    {
      path: '/system/hk',
      component: Hk
    },
    {
      path: '/log/operate/list',
      component: Operatelog
    },
    {
      path: '/role/list',
      component: Role
    },
    {
      path: '/member/vip_application',
      component: VIP_Application 
    },
    {
      path: '/financial/balance_record_list',
      component: BalanceRecordList
    },
    {
      path: '/financial/withdraw_transfer',
      component: WithdrawTransfer
    },
    {
      path: '/financial/recharge_record_list',
      component: RechargeRecord
    },
    {
      path: '/system/setting',
      component: SettingPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/views/main/router/index.js